import React from 'react'

// store
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
// actions
import * as USER_ACTION from '@store/user/actions'
import * as SHARED_ACTION from '@store/shared/actions'

import { Svg } from '@components/shared/elements'
import { Modal } from '@components/shared/elements'

import TOOLS from '@helpers/tools'
import slugify from 'slugify'
import { isEmpty } from 'lodash'

class Modalwelcome extends React.Component {

    constructor(props) {
        super(props)
        this.state = {}
        this.el = React.createRef()
    }

    _switchModal(modal, goback = false) {
        this.props.actions.setContactModalsState(this.props.contactModals, modal, true)
        this.props.actions.optionsModals(goback)
    }

    _gaWhatsapp = (element) => {
        const elementText = element._targetInst !== null ? slugify(element.target.innerText, { lower: true }) : 'whatsapp',
            timeStamp = Date.now()
        let dataLayer = window['dataLayer'],
            page = window.location.pathname.split('/')[1]

        if (!isEmpty(page)) {
            page = 'home'
        }

        if (dataLayer) {
            let ecommerce = {}
            if (window.location.href.indexOf('apartamento/') > 0) {
                const product = this.props.product.imovel
                let nome = slugify(product.Nome, { lower: true }),
                    estado = slugify(product.Localizacao.Estado, { lower: true }),
                    cidade = slugify(product.Localizacao.Cidade, { lower: true }),
                    bairro = slugify(product.Localizacao.Bairro, { lower: true }),
                    marca = 'vivaz',
                    preco = new Intl.NumberFormat('pt-BR').format(product.PrecoMinimo)
                    ecommerce = {
                        purchase:{
                            actionField:{
                                id: `${timeStamp}`,
                            },
                            products: {
                                id: `${product.imovelId}`,
                                name: `${nome}`,
                                brand: `${marca}`,
                                category: `${estado}/${cidade}`,
                                variant: `${bairro}/${product.Quartos}/${product.AreaPrivativaM2}`,
                                price: `${preco}`,
                            },
                        },
                    }
            } else {
                ecommerce = {
                    purchase:{
                        actionField:{
                            id: `${timeStamp}`,
                        },
                        products: {
                            id: 'na',
                            name: 'na',
                            brand: 'vivaz',
                            category: 'na',
                            variant: 'na',
                            price: 1,
                        },
                    },
                }
            }
            dataLayer.push({
                'event': 'purchase',
                'eventCategory': `${page}`,
                'eventAction': `${elementText}:click`,
                'eventLabel': `${elementText}:${timeStamp}`,
                ecommerce,
            })
        }
    }

    _checkUrl() {
        const currentPath = window.location.pathname
        let pdp = ''
      
        if (currentPath.includes('/apartamento')) {
          pdp = true
        } else {
          pdp = false
        }
        return pdp
      }
    _createWhatsappUrl(event, phone, typeIntegrationLead, idImovel) {
      const { region } = this.props
      const imovel = this.props.product && this.props.product.imovel
      const gaWhatsAppFunction = this._gaWhatsapp
      let pdp = this._checkUrl()
      TOOLS.createWhatsappUrl({
        event,
        imovel,
        region,
        gaWhatsAppFunction,
        phone,
        typeIntegrationLead,
        pdp,
        idImovel,
      })
    }

    render() {
        let { phone } = this.props
        if (!isEmpty(phone)) {
        if (phone.TelefoneVendaContatoMobile != null) {
            phone.TelefoneVendaContatoMobileH = phone.TelefoneVendaContatoMobile.replace(/-|\s/g, '').replace(/\(|\s/g, '').replace(/\)|\s/g, '')
        }
        if (phone.TelefoneVendaContatoWhatsApp != null) {
            phone.TelefoneVendaContatoWhatsAppH = phone.TelefoneVendaContatoWhatsApp.replace(/-|\s/g, '').replace(/\(|\s/g, '').replace(/\)|\s/g, '')
        }
        }
        return <Modal show={this.props.show} extraClass='modal-welcome' close={this.props.close} fullscreen={false} goback={this.props.goback}>
            <h4 className='h5 mt3 mb2'><strong>Receba mais informações:</strong></h4>
            <p className='mb4'>Fale com um de nossos vendedores!</p>
            {!isEmpty(phone) && phone.TelefoneVendaContatoWhatsAppH &&
              <button
                onClick={event => this._createWhatsappUrl(
                  event,
                  phone.TelefoneVendaContatoWhatsAppH,
                  phone.TipoGuidIntegracao
                )}
                data-ga-action
                className='mb4'>
                  <Svg src='/Files/vivaz.com.br/content/img/icons/ico-whatsapp.svg' />
                  WhatsApp
              </button>
            }
            {!isEmpty(phone) && !phone.TelefoneVendaContatoWhatsAppH &&
                <span onClick={() => this._switchModal('modalWhats')} data-ga-action className='span-anchor mb4'><Svg src='/Files/vivaz.com.br/content/img/icons/ico-whatsapp.svg' /> WhatsApp</span>
            }
            {(!(TOOLS.isMobile())) && !isEmpty(phone) && phone.TelefoneVendaContatoMobileH &&
                <span onClick={() => this._switchModal('modalCall')} data-ga-action className='span-anchor mb4'><Svg src='/Files/vivaz.com.br/content/img/icons/ico-central-phone.svg' /> Telefone</span>
            }
            {(TOOLS.isMobile()) && !isEmpty(phone) && phone.TelefoneVendaContatoMobile != null &&
                <a href={`tel:+55${phone.TelefoneVendaContatoMobile}`} data-ga-action className='mb4'><Svg src='/Files/vivaz.com.br/content/img/icons/ico-central-phone.svg' /> Telefone</a>
            }
            <p className='site-go' onClick={this.props.close}>Ir para o Site</p>
        </Modal>
    }
}
const mapStateToProps = state => {
    return {
        currentUser: state.user.currentUser,
        product: state.products.product,
        region: state.shared.region,
        phone: state.shared.phone,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators({
            ...USER_ACTION,
            ...SHARED_ACTION,
        }, dispatch),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Modalwelcome)



// WEBPACK FOOTER //
// ./src/components/children/contactForm/ModalWelcome.js